<template>
  <div class="logo">
    <LoadingIndicator
        v-if="loading"
        class="primary big"
    />
    <div v-if="!loading" class="logo_bg sidebar_logo"></div>
  </div>
</template>

<script>
  import LoadingIndicator from '@/components/LoadingIndicator/LoadingIndicator'
  import { mapGetters, mapActions } from 'vuex';
  export default {
    name: "Loading",
    components: {
      LoadingIndicator
    },
    computed: {
      ...mapGetters({
        loading: 'loading/is',
      }),
    },
  }
</script>

<style scoped lang="scss">
.logo {
  width: 4rem;
  height: 4rem;
}
.logo_bg {
  width: 4rem;
  height: 4rem;
  background-image: url("../assets/img/ans_logo.png");
  background-size: cover;
}
</style>
